import ComicsList from '../comicsList/ComicsList';
import AppBanner from '../appBanner/AppBanner';

const Comicspage = () => {
  return (
    <>
      <AppBanner />
      <ComicsList />
    </>
  );
};

export default Comicspage;
